// Centralizes the "keep this open"/"safe to close" copy shown while a photo
// upload/grouping job is in progress - previously duplicated verbatim in
// EventPage.js's SmartSortSection and AddPhotosSection, and absent entirely
// from the attendee "Submit Photos" and upload-link manual-upload flows.
import { Capacitor } from '@capacitor/core';

export const UPLOAD_IN_PROGRESS_WARNING =
  'Keep this page open while photos upload. Once upload is complete, grouping will continue even if you leave.';
export const GROUPING_IN_PROGRESS_NOTICE =
  'Grouping is running on the server - you can safely close this page and come back later to see progress.';
export const UPLOAD_BACKGROUNDABLE_NOTICE =
  'Uploading in the background - you can close the app and it will keep going.';

// On native, uploads themselves are backgroundable (see the native
// background-upload feature: stagingProvider.js + FolderSyncForegroundService's
// upload-job half) - only the PWA/browser still needs the "keep this open"
// warning during the upload phase. The grouping-phase notice remains true
// everywhere (grouping always ran server-side, on every platform, even
// before this feature existed).
export function shouldShowUploadWarning() {
  return !Capacitor.isNativePlatform();
}

export function shouldShowBackgroundableNotice() {
  return Capacitor.isNativePlatform();
}
